var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"font-weight-bold text-right",class:_vm.labelClass},[_vm._v(_vm._s(_vm.label))]),_c('div',{staticClass:"col"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }